export default "\r\n<iframe class=\"contenido\" [src]=\"pdfSrcSecure\"></iframe>\r\n\r\n"